import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/navCategories';
const rootActionPathTOF = 'core/navCategoriesTOF';

export const NAV_CATEGORIES_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const NAV_CATEGORIES_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
export const NAV_CATEGORIES_TOF_ITEM_IS_VIEWED = `${rootActionPathTOF}/IS_VIEWED`;
